import { Location } from 'history'

export enum ActionScreen {
    PRODUCT_LIST = 'Product List',
    PRODUCT_DETAIL = 'Product Detail',
    SEARCH_RESULT_LIST = 'Search Result List',
    CART = 'Cart',
}

export const getActionScreen = ({ pathname, search }: Location): ActionScreen => {
    if (pathname.includes('cart')) {
        return ActionScreen.CART
    }

    if (pathname.includes('product')) {
        return ActionScreen.PRODUCT_DETAIL
    }

    if (search) {
        return ActionScreen.SEARCH_RESULT_LIST
    }

    return ActionScreen.PRODUCT_LIST
}
